import ExpandedCell from './ExpandedCell';

export default ExpandedCell;
